import React from 'react';

import Button from 'components/basic/Button/Button';
import { staticDispatch } from 'reduxState/store';
import { showWalletModal } from 'reduxState/wallet/walletDetailsReducer';

type Props = Partial<React.ComponentProps<typeof Button>>;

/** Inline "Wallet unlock", "Connect Wallet/ ConnectWallet" Button */
export default function UnlockWalletButton({
  children,
  ...buttonProps
}: Props) {
  return (
    <Button
      {...buttonProps}
      onClick={() => {
        staticDispatch(showWalletModal());
        // Call parrent onClick if available
        buttonProps.onClick?.();
      }}
    >
      {children ?? 'Connect Wallet'}
    </Button>
  );
}
